export default __webpack_public_path__ + "static/media/import.26346ad4.svg";